import { ref } from "vue";
import { defineStore } from "pinia";
import useMyFetch from "@stores/useMyFetch";
import handleError from "@utils/composables/handleError";
import { getRegionOptions } from "@utils/constants/regions";
import { getClientId } from "@utils/clientId";
import { captureEvent } from "@/lib/analytics";

export const useSyncMultiCountryModal = defineStore("syncMultiCountryModal", () => {
  const currentCountries = ref([]); // array of country objects
  const selectedCountries = ref([]); // array of country codes
  const currentTokenCampaign = ref(null);
  const isVisible = ref(false);
  const isSyncing = ref(false);

  const resetModalState = () => {
    currentCountries.value = [];
    selectedCountries.value = [];
    currentTokenCampaign.value = null;
  };

  const hideModal = () => {
    isVisible.value = false;
    resetModalState();
  };

  const showModal = async (token, countries) => {
    resetModalState();
    currentTokenCampaign.value = token;
    currentCountries.value = getRegionOptions().filter((obj) => countries.includes(obj.value));
    isVisible.value = true;
  };

  const handleSync = async () => {
    if (!selectedCountries.value.length || isSyncing.value) return;

    try {
      isSyncing.value = true;
      const body = { countries_to_sync: selectedCountries.value, client_id: getClientId() };
      const { response } = await useMyFetch(`/m_campaigns/${currentTokenCampaign.value}/sync_multicountry`)
        .json()
        .post(body);

      if (response.value.ok) {
        captureEvent("m_campaign_multicountry_synced", {
          m_campaign_token: currentTokenCampaign.value,
          countries_count: selectedCountries.value.length,
        });
      }

      hideModal();
    } catch (err) {
      handleError(err);
    } finally {
      isSyncing.value = false;
    }
  };

  const handleSelection = (country) => {
    const index = selectedCountries.value.findIndex((item) => item === country.value);
    if (index > -1) {
      // Finds a country, then deletes it from the selection array
      selectedCountries.value.splice(index, 1);
    } else {
      // Does not find the country, then just adds it to the selection array
      selectedCountries.value.push(country.value);
    }
  };

  return {
    isVisible,
    isSyncing,
    currentCountries,
    selectedCountries,
    hideModal,
    showModal,
    handleSync,
    handleSelection,
  };
});
